import type { AppEnvironmentType } from '../../shared/types/app/AppEnvironmentType';

export const isEmbeddedAppEnvironment = (
  appEnvironmentType?: AppEnvironmentType,
) => {
  return appEnvironmentType === 'embedded';
};
